import React from 'react'
import PropTypes from 'prop-types'

import routes from 'src/lib/rails-routes/rails-routes'
import { Box, Flex, Image } from '@chatterbug/aaron'
import Action from 'src/ui/Action/Action'
import { t } from 'src/lib/i18n-react'
import Favorite from 'src/ui/Favorite/Favorite'

import TutorLanguages from './subcomponents/TutorLanguages/TutorLanguages'
import lessonIcon from './assets/lesson.svg'
import locationIcon from './assets/location.svg'
import DetailedTutorInfoCardSkeleton from './DetailedTutorInfoCardSkeleton'
import TutorAvatar from './subcomponents/TutorAvatar/TutorAvatar'

const IconSection = ({ isFavorite, avatarUrl, tutorName }) => {
  // TODO: figure out if there is a better way to achieve the different styles
  // for mobile and tablet+
  // TODO: add online indicator for tutor
  return (
    <Box sx={{ position: 'relative' }}>
      {isFavorite && (
        <>
          <Box
            height="24px"
            width="24px"
            display={{ _: 'inline-block', tablet: 'none' }}
            sx={{ position: 'absolute', top: '0', right: '0' }}
          >
            <Favorite />
          </Box>
          <Box
            display={{ _: 'none', tablet: 'inline-block' }}
            height="24px"
            width="24px"
            as="span"
            sx={{ position: 'absolute', top: '0', right: '0' }}
          >
            <Favorite />
          </Box>
        </>
      )}
      <TutorAvatar avatarUrl={avatarUrl} tutorName={tutorName} size="small" />
    </Box>
  )
}

const DetailedTutorInfoCard = ({
  isFavorite,
  avatarUrl,
  name,
  login,
  countOfLessons,
  location,
  fluentLanguages,
}) => {
  const profileUrl = routes.profile({ login: login })
  return (
    <DetailedTutorInfoCardSkeleton
      iconSection={
        <IconSection
          avatarUrl={avatarUrl}
          isFavorite={isFavorite}
          tutorName={name}
        />
      }
      nameSection={
        <Box as="text" variant="text.h4">
          {name}
        </Box>
      }
      loginSection={
        <Box as="text" variant="text.monospace">
          {login}
        </Box>
      }
      locationSection={
        location && (
          <Flex>
            <Image src={locationIcon} height="24px" width="24px" />
            <Box ml="1x" as="p" variant="text.paragraph">
              {location}
            </Box>
          </Flex>
        )
      }
      lessonsSection={
        countOfLessons && (
          <Flex>
            <Image src={lessonIcon} height="24px" width="24px" />
            <Box ml="1x" as="p" variant="text.paragraph">
              {t('%{countOfLessons} Lessons', { countOfLessons })}
            </Box>
          </Flex>
        )
      }
      languagesSection={
        fluentLanguages && <TutorLanguages fluentLanguages={fluentLanguages} />
      }
      linkSection={<Action href={profileUrl}>{t('View profile')}</Action>}
    />
  )
}

DetailedTutorInfoCard.propTypes = {
  isFavorite: PropTypes.bool,
  avatarUrl: PropTypes.string,
  name: PropTypes.string,
  login: PropTypes.string,
  countOfLessons: PropTypes.number,
  location: PropTypes.string,
  fluentLanguages: PropTypes.array,
}

export default DetailedTutorInfoCard
